// role-permission.map.ts
import { Role, RoleID } from "./role.enum";
import { Permission } from "./permission.enum";

export const ROLE_PERMISSION_MAP: Record<RoleID, Permission[]> = {
  [RoleID.PARENT]: [Permission.ASSIGN_COURSE, Permission.STUDENT_MANAGE],
  [RoleID.MEMBER]: [Permission.ENTER_COURSE],
};
